import { render, staticRenderFns } from "./ChangelogPanel.vue?vue&type=template&id=6fd35807&scoped=true&"
import script from "./ChangelogPanel.vue?vue&type=script&lang=js&"
export * from "./ChangelogPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogPanel.vue?vue&type=style&index=0&id=6fd35807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd35807",
  null
  
)

export default component.exports